import React from "react";
import logo from "./../../images/header-logo.svg";
import { useDispatch } from "react-redux";

import { logOut } from "../../app/user/userSlice";

import logouticon from "../../images/icons/logout-icon.svg";

export const Header = () => {
  const dispatch = useDispatch();

  const handleLogout = (instance) => {
    // instance.logoutRedirect().catch((e) => {});
    localStorage.setItem("dbhuseread", false);
    dispatch(logOut());
    // window.location.reload();
    window.open(process.env.REACT_APP_LANDING_REDIRECT, '_self')
  };

  return (
    <div className="main-header">
      <img alt="logo" src={logo} />
        <button
          onClick={handleLogout}
          className="main-header__logout-button"
        >
          <img
            src={logouticon}
            alt="logout-img"
            className="main-header__logout-icon"
          />
          Cerrar sesión
        </button>
    </div>
  );
};